// extracted by mini-css-extract-plugin
module.exports = {"whats-float":"SideWhatsapp_whats-float__qupCA","sidebaricon":"SideWhatsapp_sidebaricon__RYIdz","hitherewhatsapp":"SideWhatsapp_hitherewhatsapp__CqoBb"};